import * as React from 'react';
import { createElement } from 'react';
import { articleListAuthorityPage } from '../../http/api';
import baseURL from '../../http/url';
import './index.scss';
export default class Article extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            dataArr: [],
            type: "",
            style: {},
            arr: [],
            height: '100%',
            width: '100%'
        };
    }
    componentDidMount() {
        this.setState({ type: this.props.type });
        this.articleListPageRequest(this.props);
    }
    articleListPageRequest = (nextProps) => {
        const params = {
            pageSize: nextProps.limit * nextProps.column,
            pageNum: 1,
            articleTypeIds: nextProps.articleArr
        };
        articleListAuthorityPage(params).then(({ resultCode, data }) => {
            if (resultCode === 200) {
                this.setState({
                    dataArr: data.list.map(item => {
                        return {
                            imgUrl: `${baseURL.url}/image/${item.articleImgUrl}`,
                            articleTitle: item.articleTitle,
                            articleId: item.articleId,
                            createDate: item.createDate
                        };
                    }),
                    type: nextProps.type,
                    arr: []
                });
                this.setArr(nextProps);
            }
        });
    };
    getArr = (num, arrLength, length) => {
        const index = num ? length : 0;
        this.state.arr.push({
            imgUrl: this.state.dataArr[index].imgUrl,
            arrChildren: this.state.dataArr.slice(index, index + arrLength)
        });
        this.setState(prev => ({
            arr: prev.arr,
            height: `${(100 / prev.arr.length).toFixed(1)}%`,
            width: `${(100 / prev.arr.length).toFixed(1)}%`,
        }));
    };
    componentWillReceiveProps(nextProps) {
        if (this.props.type !== nextProps.type) {
            if (this.state.dataArr.length)
                this.articleListPageRequest(nextProps);
        }
        if (this.props.limit !== nextProps.limit || this.props.column !== nextProps.column) {
            if (this.state.dataArr.length)
                this.articleListPageRequest(nextProps);
        }
        if (this.props.articleArr.length !== nextProps.articleArr.length) {
            this.articleListPageRequest(nextProps);
        }
    }
    setArr = (nextProps) => {
        if (nextProps.type !== 'content' && nextProps.column) {
            for (let i = 0; i < nextProps.column; i++) {
                const key = i ? nextProps.limit * i : 0;
                if (this.state.dataArr.length > key)
                    this.getArr(i, nextProps.limit, key);
            }
        }
    };
    render() {
        return (createElement("div", { style: { height: "200px", padding: "10px", ...this.props.style } },
            this.state.type == 'twoLeft' &&
                this.state.arr.map((val, key) => createElement("div", { className: "article-card custom article-common", key: key, style: { height: this.state.height, width: '100%' } },
                    createElement("img", { src: val.imgUrl, style: { width: "40%", height: "100%" } }),
                    createElement("div", null, val.arrChildren.map((item, index) => createElement("div", { key: index, style: { color: this.props.style.color || '#606266', fontWeight: this.props.style.fontWeight, fontSize: this.props.style.fontSize || '14px' } }, item.articleTitle))))),
            this.state.type == 'twoTop' && createElement("div", { className: " article-card-top" }, this.state.arr.map((val, key) => createElement("div", { className: "list article-common", key: key, style: { width: this.state.width } },
                createElement("img", { src: val.imgUrl, style: { width: "100%", height: "60%" } }),
                createElement("div", { style: { padding: '10px 2px' } }, val.arrChildren.map((item, index) => createElement("div", { key: index, style: { color: this.props.style.color || '#606266', fontWeight: this.props.style.fontWeight, fontSize: this.props.style.fontSize || '14px' } }, item.articleTitle)))))),
            this.state.type == 'content' &&
                createElement("div", { className: "article-common" }, this.state.dataArr.map((item, index) => createElement("div", { key: index, className: "ctn-data" },
                    createElement("span", { className: "title" }, item.articleTitle),
                    createElement("span", { className: "time" },
                        "[",
                        item.createDate,
                        "]"))))));
    }
}
;
